import { render, staticRenderFns } from "./CreateCalendarEvent.vue?vue&type=template&id=4205dce8&"
import script from "./CreateCalendarEvent.vue?vue&type=script&lang=js&"
export * from "./CreateCalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./CreateCalendarEvent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports